import { LogoProps } from 'types/logo.types';
import React from 'react';

export const Logo: React.FC<LogoProps> = ({ className = '' }) => {
	return (
		<div className={`text-2xl font-bold ${className}`}>
			<span className='text-blue-600'>i</span>
			<span className='text-gray-900'>talent</span>
			<span className='text-blue-600'>.</span>
		</div>
	);
};
